export default "__VITE_ASSET__1a32579d__"